module.exports = __webpack_public_path__ + "static/IMG_1436-36d2a84d80b689376d3b91eda0a082c9.jpg";